export default __webpack_public_path__ + "static/media/portada_ChiaraCarucci_ENG.ba8c073b.jpg";